// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.

export const REL_TYPE_OUTGOING = "outgoing";
export const REL_TYPE_INCOMING = "incoming";
export const REL_TYPE_ALL = "all";
export const CUSTOM_AUTH_ERROR_MESSAGE
  = `At a minimum, you’ll need read permissions to view this Azure Digital Twins instance in the Explorer. \
Talk to your Administrator, or (if you can) assign yourself to the Azure Digital Twins Data Reader role. `;
export const CUSTOM_NOT_FOUND_ERROR_MESSAGE
  = `Make sure the Azure Digital Twins URL is correct and the Azure Digital Twins instance is in the directory you selected. \
  If you have recently been added to this instance, it may take a few minutes for permissions to propagate.`;
export const CUSTOM_AZURE_ERROR_MESSAGE
  = `This feature is not yet available in Azure. Please manually configure a system-assigned managed identity for your Azure Function.`;
export const AUTH_SUCCESS_MESSAGE = "Success! Reload the page to load your new credentials. It may take several seconds for changes to propagate.";
export const AUTH_CONFLICT_MESSAGE = "Role already exists. Restart the app to reload your credentials.";
export const AUTH_FORBIDDEN_MESSAGE = "Forbidden. You do not have permission to changes roles on this twin instance";
export const AUTH_NOT_FOUND_MESSAGE = "Twin not found";
export const TWIN_DATA_OWNER_RBAC_ID = "bcd981a7-7f74-457b-83e1-cceb9e632ffe";
export const MORE_INFORMATION_LINK = "https://docs.microsoft.com/azure/digital-twins/";
export const DETAIL_MIN_WIDTH = 24;
export const PROPERTY_INSPECTOR_DEFAULT_WIDTH = 35;
export const STRING_DTDL_TYPE = "dtmi:dtdl:instance:Schema:string;2";
export const DEFAULT_DISPLAY_NAME_PROPERTY = "$dtId";
export const API_VERSION = "2021-06-30-preview";
export const ADT_ALLOW_LISTED_URLS = {
  DEV: "https://dev.explorer.azuredigitaltwins-test.net",
  PROD: "https://explorer.digitaltwins.azure.net"
};
export const LOCAL_STORAGE_KEYS = {
  FeatureFlags: {
    Telemetry: {
      // Forces telemetry to be logged to dev app insights
      forceDevAppInsights: "explorer.feature.forceDevAppInsights",
      // Enables debug logging for all emitted telemetry events
      debugLogging: "explorer.debug.telemetryLogging"
    },
    Proxy: {
      forceProxy: "explorer.feature.forceProxy"
    }
  }
};
